import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { shapeSettings } from '../../tools/hns/config';
import { dispatchMapper } from '../wizard/actions';
import Navigation from '../wizard/Navigation';
import HypotheekbondLogoSvg from 'images/shared/hypotheekbond-abc.svg';
import ErrorSvg from 'images/shared/error.svg';

function OutputContainer({
  pages,
  broken,
  children,
  sync,
  settings,
  navigationDisabled,
  disclaimerDisabled,
  forceRemoveLogo,
}) {
  const location = useLocation();
  const lastPage = location.state?.page === pages[pages.length - 1];

  const contents = broken ? (
    <div className="placeholder with-loader no-tablet-and-smaller is-broken">
      <div className="flex-container">
        <div className="flex-item">
          <ErrorSvg className="logo" />
          <p className="form-wrapper">Er is iets mis gegaan tijdens de berekening</p>
          <div className="lead-buttons input">
            <button className="rounded" onClick={() => window.location.reload()}>
              Herlaad de tool
            </button>
            <small>Of probeer het later opnieuw</small>
          </div>
        </div>
      </div>
    </div>
  ) : (
    children
  );

  return (
    <section
      className={ClassNames({
        output: true,
        'last-page': lastPage,
      })}
    >
      <div className="wrapper">
        {!navigationDisabled && (
          <div className="navigation tablet-and-smaller-only">
            <Navigation />
          </div>
        )}
        {!forceRemoveLogo && settings.enableHypotheekbondLogo ? (
          <div className="hypotheekbond-logo no-tablet-and-smaller">
            <HypotheekbondLogoSvg className="hypotheekbond-logo no-tablet-and-smaller" />
          </div>
        ) : null}
        {contents}
        {!disclaimerDisabled && (
          <footer role="presentation" className="desktop no-tablet-and-smaller">
            <button onClick={() => sync('show_disclaimer', true)}>Disclaimer</button>
          </footer>
        )}
      </div>
    </section>
  );
}

OutputContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Array)]).isRequired,
  sync: PropTypes.func.isRequired,
  broken: PropTypes.bool.isRequired,
  navigationDisabled: PropTypes.bool,
  disclaimerDisabled: PropTypes.bool,
  pages: PropTypes.arrayOf(PropTypes.string).isRequired,
  settings: shapeSettings.isRequired,
  forceRemoveLogo: PropTypes.bool,
};

OutputContainer.defaultProps = {
  forceRemoveLogo: false,
  navigationDisabled: false,
  disclaimerDisabled: false,
};

export default connect(
  state => ({
    pages: state.pages,
    broken: state.broken,
    settings: state.settings,
  }),
  dispatchMapper
)(OutputContainer);
